import { ReactElement } from 'react';

import { Portal } from '@dreryk/react-components';

const PATIENT_ASSOCIATE_MODAL_PORTAL_CONTAINER_ID = 'patientAssociateModalPortal';

export const PatientAssociateModalSubheadingPortalContainer = (): JSX.Element => {
   return (
      <Portal.Container
         testId={PATIENT_ASSOCIATE_MODAL_PORTAL_CONTAINER_ID}
         id={PATIENT_ASSOCIATE_MODAL_PORTAL_CONTAINER_ID}
      />
   );
};

type PatientAssociateModalSubheadingPortalProps = {
   readonly children: ReactElement;
};
export const PatientAssociateModalSubheadingPortal = (
   props: PatientAssociateModalSubheadingPortalProps
): JSX.Element => {
   return <Portal containerId={PATIENT_ASSOCIATE_MODAL_PORTAL_CONTAINER_ID}>{props.children}</Portal>;
};
